import { render, staticRenderFns } from "./order-cancel-dialog.vue?vue&type=template&id=0a34245b&scoped=true"
import script from "./order-cancel-dialog.vue?vue&type=script&lang=js"
export * from "./order-cancel-dialog.vue?vue&type=script&lang=js"
import style0 from "./order-cancel-dialog.vue?vue&type=style&index=0&id=0a34245b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34245b",
  null
  
)

export default component.exports